import { render, staticRenderFns } from "./InquiryVerify.html?vue&type=template&id=f0b1d13c&scoped=true&"
import script from "./InquiryVerify.vue?vue&type=script&lang=ts&"
export * from "./InquiryVerify.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryVerify.scss?vue&type=style&index=0&id=f0b1d13c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b1d13c",
  null
  
)

export default component.exports